import { Component }     from '@angular/core';
import { ControlWidget } from '../models/control-widget.directive';

/**
 * Masked secret/password widget (form type `Secret`). Mirrors the string widget but renders a
 * password field with a show/hide toggle — for tokens, API keys, and the like. Registered in
 * DefaultWidgetRegistry so any generated form can use type `'Secret'`.
 */
@Component({
	standalone: false,
	selector: 'secret-widget',
	template: `
				<div class="form-group">
					<div class="cs-secret-input">
						<input [name]="name"
							   class="form-control"
							   [type]="show ? 'text' : 'password'"
							   [formControl]="control"
							   [attr.id]="id"
							   [disabled]="readOnly"
							   [class.is-valid]="isValid"
							   [class.is-invalid]="isInValid"
							   [class.is-warning]="isInWarning"
							   autocomplete="off"
							   spellcheck="false"
						>
						<button type="button"
								class="cs-secret-toggle"
								(click)="show = !show"
								[attr.aria-label]="show ? 'Hide value' : 'Show value'"
								[title]="show ? 'Hide value' : 'Show value'">{{ show ? 'Hide' : 'Show' }}</button>
					</div>
					<div class="pm-form-element-invalid-feedback" *ngIf="errorMessages?.length > 0">
						<small class="{{error.type}}" *ngFor="let error of errorMessages">{{error.errorMessage}}</small>
					</div>
				</div>
				`,
	styles: [`
		.cs-secret-input { display: flex; align-items: stretch; gap: 0.4rem; }
		.cs-secret-input .form-control { flex: 1 1 auto; min-width: 0; }
		.cs-secret-toggle {
			flex: 0 0 auto;
			padding: 0 0.6rem;
			border: 1px solid var(--cs-border, rgba(0, 0, 0, 0.2));
			border-radius: 0.3rem;
			background: var(--cs-surface, #fff);
			color: var(--cs-text-muted, rgba(0, 0, 0, 0.6));
			cursor: pointer;
			font-size: 0.8rem;
		}
		.cs-secret-toggle:hover { color: var(--cs-accent, #0e7c66); border-color: var(--cs-accent, #0e7c66); }
	`]
})
export class SecretWidgetComponent<T> extends ControlWidget<T> {
	show = false;
}
